export default {
  SET_API_VERSION: 'SET_API_VERSION',
  SET_SIDEBAR: 'SET_SIDEBAR',
  SET_PERMISSIONS: 'SET_PERMISSIONS',
  SET_FIELD_DEFINITIONS: 'SET_FIELD_DEFINITIONS',
  SET_ERROR: 'SET_ERROR',
  CLEAR_ERROR: 'CLEAR_ERROR',
  SET_MOBILE_SIDEBAR: 'SET_MOBILE_SIDEBAR',
  SET_ALERT_MESSAGE: 'SET_ALERT_MESSAGE',
  SET_LOADING: 'SET_LOADING'
}
